var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.selectedData&&_vm.selectedData.ls450000)?_c('OrderProcess',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"list-data":_vm.listData,"selected-data":_vm.selectedData,"type":"3"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }